export const environment = {
  production: true,
  hmr: false,
  apiUrl: 'http://localhost:4000',
  kuberAiUrl: 'https://honest-caring-production-97b3.up.railway.app',
  firebase: {
    apiKey: "AIzaSyDtjJnvS-XLvnqhiQ2qicwJ1Np7jN7kmeM",
    authDomain: "lawtrax-prod.firebaseapp.com",
  }
};